import { GenericControl } from "../../../../UI.BaseControls/GenericControl";
import { Control } from "../../Controls/Control";
import { ControlParams } from "../../Controls/ControlInterfaces";

export class FormInternalPanel extends Control {
    constructor(params: ControlParams) {
        super(params);
        const { element } = params;

        element.classList.add("FormInternalPanel");

        const details: HTMLElement[] = Array.from(element.querySelectorAll("[data-tscControl=DetailFrame]"));
        for (const detail of details) {
            if (GenericControl.hasParent(detail, "[data-behaviour=container]")) // bohužel z XGenu vždycky přijdou nějaké rozměry (jinak by ho v XGenu vůbec neviděli), ale v kontejneru si to řeší kontejner sám
                continue;

            const height = parseFloat(detail.getAttribute("data-height"));
            if (height)
                detail.style.height = (height + 5) + "px";

            const width = parseFloat(detail.getAttribute("data-width"));
            if (width)
                detail.style.width = (width + 5) + "px";
        }
    }
}
